const getStoredMode = () => {
  const stored = localStorage.getItem('theme-mode')
  return stored || 'light'
}

const getStoredPrimaryColor = () => {
  const stored = localStorage.getItem('theme-primary')
  return stored || '#155dfc'
}

export default {
  namespaced: true,

  state: () => ({
    mode: getStoredMode(),
    primaryColor: getStoredPrimaryColor(),
    availablePrimaryColors: [
      { name: 'Blau', value: '#155dfc' },
      { name: 'Indigo', value: '#6366f1' },
      { name: 'Violett', value: '#8b5cf6' },
      { name: 'Pink', value: '#ec4899' },
      { name: 'Rot', value: '#ef4444' },
      { name: 'Orange', value: '#f97316' },
      { name: 'Amber', value: '#f59e0b' },
      { name: 'Grün', value: '#22c55e' },
      { name: 'Teal', value: '#14b8a6' },
      { name: 'Cyan', value: '#06b6d4' }
    ]
  }),

  mutations: {
    SET_MODE(state, mode) {
      state.mode = mode
      localStorage.setItem('theme-mode', mode)
    },
    SET_PRIMARY_COLOR(state, color) {
      state.primaryColor = color
      localStorage.setItem('theme-primary', color)
    }
  },

  actions: {
    init() {
      const mode = getStoredMode()
      const color = getStoredPrimaryColor()
      document.documentElement.setAttribute('data-theme', mode)
      document.documentElement.style.setProperty('--primaryColor', color)
    },
    toggleMode({ commit, state }) {
      const newMode = state.mode === 'light' ? 'dark' : 'light'
      commit('SET_MODE', newMode)
      document.documentElement.setAttribute('data-theme', newMode)
    },
    setPrimaryColor({ commit }, color) {
      commit('SET_PRIMARY_COLOR', color)
      document.documentElement.style.setProperty('--primaryColor', color)
    }
  },

  getters: {
    isDarkMode: state => state.mode === 'dark',
    currentPrimaryColor: state => state.primaryColor
  }
}